export class ColumnModel {
    constructor(
        public id?: number,
        public name?: string,
        public category?: ColumnCategory,
        public selected?: boolean,
        public typeId?: number,
        public visible = true) {
    }
}

export enum ColumnCategory {
    STATIC = 'STATIC',
    VARIABLE = 'VARIABLE'
}